import { Checkbox, Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { CheckboxGroupButtons } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  QuestReportReturnedPurchaseFormValues,
  ReturnedPurchaseFilterBy,
  ReturnedPurchaseSituation,
} from '@/core/domain/questReport/Reports/Purchase/Purchase.types';

export default function ReturnedPurchasesForm() {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;
  const form = Form.useFormInstance<QuestReportReturnedPurchaseFormValues>();

  const dateFilterOptions = [
    {
      value: ReturnedPurchaseFilterBy.releaseDate,
      label: intl({ id: 'returnedPurchases.option.release' }),
    },
    {
      value: ReturnedPurchaseFilterBy.issueDate,
      label: intl({ id: 'returnedPurchases.option.emission' }),
    },
  ];

  const statusOptions = [
    {
      value: ReturnedPurchaseSituation.situationCredit,
      label: intl({ id: 'returnedPurchases.option.creditValue' }),
    },
    {
      value: ReturnedPurchaseSituation.situationDebit,
      label: intl({ id: 'returnedPurchases.option.deductedAmount' }),
    },
  ];
  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <Form.Item
            name="dateFilter"
            style={{ margin: '4px 0' }}
            label={
              <Title level={5} style={{ margin: '0' }}>
                {intl({ id: 'returnedPurchases.label.filterByDate' })}
              </Title>
            }
            initialValue={ReturnedPurchaseFilterBy.releaseDate}
          >
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              size="large"
              options={dateFilterOptions}
            />
          </Form.Item>
        }
      />

      <Form.Item
        name="situation"
        style={{ margin: '4px 0' }}
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'returnedPurchases.label.status' })}
          </Title>
        }
        initialValue={[ReturnedPurchaseSituation.situationCredit]}
      >
        <CheckboxGroupButtons options={statusOptions} />
      </Form.Item>

      <Row gutter={16}>
        <Col>
          <Form.Item name="detailReturnedItems" valuePropName="checked">
            <Checkbox>Detalhar itens retornados</Checkbox>
          </Form.Item>
        </Col>

        <Col>
          <Form.Item name="detailUnspentCredit" valuePropName="checked">
            <Checkbox>
              {intl({ id: 'returnedPurchases.checkbox.usedCreditDetail' })}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col>
          <Form.Item name="detailSpentCredit" valuePropName="checked">
            <Checkbox>
              {intl({ id: 'returnedPurchases.checkbox.creditToUseDetail' })}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
